export default __webpack_public_path__ + "static/media/raffaello.16b4d7f6.png";